import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import format from 'date-fns/format';

export const GET_FORM_BY_ID_REQUEST = 'GET_FORM_BY_ID_REQUEST';
export const GET_FORM_BY_ID_SUCCESS = 'GET_FORM_BY_ID_SUCCESS';
export const GET_FORM_BY_ID_FAILURE = 'GET_FORM_BY_ID_FAILURE';

function request() {
  return {
    type: GET_FORM_BY_ID_REQUEST
  };
}

function receive(formData, validationResult, supportingDocs, formReviewState, workflowState) {
  return {
    type: GET_FORM_BY_ID_SUCCESS,
    formData,
    validationResult,
    supportingDocs,
    formReviewState,
    workflowState,
    formError: null
  };
}

function reject(formError) {
  return {
    type: GET_FORM_BY_ID_FAILURE,
    formError
  };
}

function checkSignature(data, partName, dateFormat) {
  const signedName = 'NOT YET REQUESTED';
  if (data != null) {
    if (data[partName] != null && !data[partName].signature) {
      data[partName].signature = signedName;
    } else if (data[partName] === null) {
      data[partName] = {
        signature: signedName,
        date: format(new Date(), dateFormat),
        dateSigned: format(new Date(), dateFormat)
      };
    }
  }
}

export function getFormById(formType, formId) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .getFormById(formType, formId)
      .then((response) => {
        if (response.data && response.data.data) {
          response.data.data.customerDbId = response.data.customer;
          response.data.data.accountId = response.data.account;

          switch (formType) {
            case 'w9_2018':
              checkSignature(response.data.data, 'certification', 'MM-dd-yyyy');
              break;
            case 'w8ben':
            case 'w8ben_2021':
              checkSignature(response.data.data, 'part3', 'MM-dd-yyyy');
              break;
            case 'w8bene_2017':
            case 'w8bene_2021':
              checkSignature(response.data.data, 'part30', 'MM-dd-yyyy');
              break;
            case 'w8eci':
            case 'w8eci_2021':
              checkSignature(response.data.data, 'part2', 'MM-dd-yyyy');
              break;
            case 'w8imy_2017':
              checkSignature(response.data.data, 'part29', 'MM-dd-yyyy');
              break;
            case 'w8exp':
              checkSignature(response.data.data, 'part4', 'MM-dd-yyyy');
              break;
            case 'crsi':
              checkSignature(response.data.data, 'part3', 'dd-MM-yyyy');
              break;
            case 'crse':
              checkSignature(response.data.data, 'part4', 'dd-MM-yyyy');
              break;
            case 'crscp':
              checkSignature(response.data.data, 'part4', 'dd-MM-yyyy');
              break;
            default:
          }
        }
        dispatch(receive(response.data.data, response.data.validationResult, response.data.supportingDocs,
          response.data.review, response.data.workflowState));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          const code = error.response && error.response.data && error.response.data.error && error.response.data.error.code;
          if (code !== 401) {
            dispatch(handleException(error, reject, !code || (code !== 404 && code !== 401)));
          }
        }
      });

    return promise();
  };
}
